import { isBodexDkHostname, isSpanishMarketVisit } from '../utils/spanishMarket';

// Copy for Danish domestic homes only. The Spanish routes and other languages
// continue to use the existing translations, including when navigating in-app.
export const danishDomesticCopy = {
  'header.home': 'Hjem',
  'header.createAd': 'Opret annonce',
  'header.valueHome': 'Få værdiestimat',
  'header.faq': 'Spørgsmål',
  'header.login': 'Log ind',
  'common.home': 'Forside',
  'common.value': 'Se boligens værdi',
  'common.valueHome': 'Boligvurdering',
  'header.allObjects': 'Alle boliger',
  'header.broker': 'Mæglere',
  'home.heroTitle': 'Værdiestimat for din bolig',
  'home.heroSubtitle': 'Få et gratis værdiestimat af din bolig, chat med ejendomsmæglere og sammenlign salærer.',
  'home.addressPlaceholder': 'Indtast boligens adresse',
  'home.addressRequired': 'Indtast boligens adresse',
  'home.addressSuggestionRequired': 'Vælg boligens adresse på listen',
  'home.featureSafeTitle': 'Gratis og uforpligtende',
  'home.featureSafeBody': 'Bodex er gratis for boligsælgere. Du har kontrol over dine oplysninger og bestemmer selv, om du vil gå videre.',
  'home.featureValueTitle': 'Sammenlign ejendomsmæglere',
  'home.featureValueBody': 'Sammenlign tilbud og salærer, og vælg den ejendomsmægler, der passer til dit boligsalg.',
  'home.featureValuationTitle': 'Få overblik over boligværdien',
  'home.featureValuationBody': 'Få et AI-baseret estimat af boligens markedsværdi som udgangspunkt for dine overvejelser om salg.',
  'home.stepOneTitle': 'Fortæl om din bolig',
  'home.stepOneBody': 'Udfyld oplysningerne om din bolig. Kun ejendomsmæglere, hvis identitet Bodex har bekræftet, kan se din boligannonce.',
  'home.stepTwoTitle': 'Få et værdiestimat',
  'home.stepTwoBody': 'Bodex beregner et værdiestimat ud fra dine oplysninger og markedsdata. Overvejer du at sælge, kan du også få tilbud fra ejendomsmæglere.',
  'home.stepThreeTitle': 'Vælg den rette mægler',
  'home.stepThreeBody': 'Sammenlign tilbuddene, og vælg selv, hvilken ejendomsmægler du vil gå videre med.',
  'cta.body': 'Tag første skridt mod dit boligsalg med Bodex. Opret en boligannonce, og sammenlign dine muligheder. Gratis og uforpligtende for boligsælgere.',
  'faq.title': 'Ofte stillede spørgsmål',
  'faq.items': [
    { q: 'Hvad er Bodex?', a: 'Bodex er en digital tjeneste, hvor du kan få et gratis, AI-baseret estimat af din boligs markedsværdi. Overvejer du at sælge, kan du også komme i kontakt med ejendomsmæglere og sammenligne deres tilbud.' },
    { q: 'Hvilke oplysninger indgår i boligvurderingen?', a: 'Du kan beskrive boligens beliggenhed, stand, materialer og eventuelle renoveringer. Bodex bruger dine oplysninger sammen med markedsdata til at beregne et værdiestimat.' },
    { q: 'Hvordan får jeg et værdiestimat?', a: 'Start med boligens adresse, og besvar spørgsmålene om boligen. Bodex bruger dine svar og markedsdata til at beregne et estimat af boligens værdi.' },
    { q: 'Kan jeg blive kontaktet af en ejendomsmægler?', a: 'Hvis du oplyser, at du overvejer at sælge, kan udvalgte ejendomsmæglere kontakte dig med rådgivning og hjælp til et eventuelt boligsalg. Bodex har bekræftet disse mægleres identitet.' },
    { q: 'Hvordan bliver mine oplysninger behandlet?', a: 'Du kan læse om, hvilke oplysninger Bodex behandler, hvornår de deles med ejendomsmæglere, og hvilke rettigheder du har, i vores privatlivspolitik.' },
    { q: 'Er boligvurderingen gratis?', a: 'Ja. Værdiestimatet er gratis og uforpligtende. Du behøver hverken at sælge din bolig eller at indgå en aftale med en ejendomsmægler.' },
    { q: 'Hvor præcist er værdiestimatet?', a: 'Værdiestimatet er vejledende og bygger på de tilgængelige oplysninger om boligen og markedet. Det er ikke en garanti for salgsprisen. En ejendomsmægler kan give en mere konkret vurdering efter at have set boligen.' },
    { q: 'Hvordan kommer jeg i gang?', a: 'Indtast boligens adresse, og følg trinene i boligvurderingen. Hav gerne oplysninger om boligens størrelse, byggeår og stand klar.' },
  ],
  'footer.description': 'Bodex hjælper dig med at få overblik over din boligs værdi og sammenligne ejendomsmæglere og salærer før et boligsalg.',
  'footer.navigate': 'Genveje',
  'cookie.intro': 'Vi bruger cookies til at forbedre din oplevelse på hjemmesiden, vise tilpasset indhold og annoncer samt analysere trafikken. Klikker du på “Accepter alle”, giver du samtykke til brugen af disse cookies.',
  'cookie.essentialBody': 'Får hjemmesidens grundlæggende funktioner til at virke. Kan ikke slås fra.',
  'cookie.functionalBody': 'Gør det muligt at huske dine valg og tilpasse hjemmesiden.',
  'cookie.analyticsBody': 'Hjælper os med at forstå, hvordan besøgende bruger hjemmesiden.',
  'brokerProfile.loadError': 'Mægleroplysningerne kunne ikke hentes. Prøv igen.',
  'brokerProfile.noDescription': 'Der er endnu ingen beskrivelse.',
  'brokerProfile.loadingBroker': 'Henter mægleroplysninger...',
  'brokerProfile.averageRating': 'Gennemsnitlig bedømmelse',
  'brokerProfile.rating': 'Bedømmelse',
  'brokerProfile.date': 'Dato',
  'valuationPage.title': 'Boligvurdering',
  'valuationPage.introTitle': 'Få et gratis værdiestimat af din bolig',
  'valuationPage.introBody': 'Start med boligens adresse, og fortæl os om boligen. Så beregner Bodex et vejledende estimat af boligens markedsværdi. Det er gratis og uforpligtende.',
  'valuationPage.howTitle': 'Sådan beregnes dit værdiestimat',
  'valuationPage.howBody': 'Bodex bruger oplysninger om blandt andet beliggenhed, størrelse og stand sammen med markedsdata til at beregne et AI-baseret værdiestimat.',
  'valuationChat.getValuation': 'Få mit værdiestimat',
  'valuationChat.questions.propertyType': 'Hvilken type bolig vil du have vurderet?',
  'valuationChat.questions.area': 'Hvor stort er boligarealet i m²?',
  'valuationChat.questions.floor': 'Hvilken etage ligger lejligheden på?',
  'valuationChat.questions.plotSize': 'Hvor stor er grunden i m²?',
  'valuationChat.questions.constructionYear': 'Hvornår er boligen bygget?',
  'valuationChat.questions.email': 'Indtast din e-mailadresse for at modtage dit værdiestimat',
  'valuationChat.conditionOptions.veryGood': 'Som ny eller nyrenoveret',
  'valuationChat.conditionOptions.normal': 'Normal stand med almindeligt slid',
  'valuationChat.conditionOptions.renovate': 'Trænger til en større renovering',
  'valuationResult.generating': 'Beregner dit værdiestimat',
  'valuationResult.title': 'Dit værdiestimat',
  'valuationResult.valuationTitle': 'Boligens anslåede værdi',
  'valuationResult.done': 'Dit værdiestimat er klar',
  'valuationResult.processing': 'Vi er ved at beregne dit værdiestimat. Du kan roligt forlade siden. Vi sender resultatet til din e-mailadresse.',
  'followUp.questionProgress': 'Spørgsmål {current} af ca. {total}',
  'followUp.title': 'Flere oplysninger om din bolig',
  'followUp.intro': 'Besvar spørgsmålene om din bolig på {address}, så vi kan lave en mere udførlig boligannonce.',
  'followUp.validationMin': 'Dit svar skal indeholde mindst ét tegn.',
  'followUp.validationMax': 'Dit svar må højst indeholde {max} tegn.',
  'followUp.validationUnsafe': 'Dit svar indeholder tegn eller kode, som ikke er tilladt.',
  'followUp.validationEmpty': 'Skriv et svar, før du går videre.',
  'objectForm.emailPlaceholder': 'din@email.dk',
  'objectForm.area': 'Boligareal (m²)',
  'objectForm.displayContact': 'Vis mine kontaktoplysninger til ejendomsmæglere',
  'objectForm.displayContactHelp': 'Vælger du dette, kan ejendomsmæglere se boligens præcise adresse og dine kontaktoplysninger. Ellers er du anonym, indtil du selv vælger at dele oplysningerne.',
  'objectForm.descriptionImages': 'Beskrivelse og billeder',
  'objectForm.renovatedHelp': 'Sæt flueben, hvis boligen er renoveret, og beskriv arbejdet.',
  'objectForm.renovationsPlaceholder': 'Beskriv, hvad der er renoveret, hvornår og af hvem.',
  'objectForm.requirements': 'Har du særlige ønsker til boligsalget?',
  'objectForm.requirementsHelp': 'Sæt flueben, og beskriv dine ønsker.',
  'objectForm.requirementsLabel': 'Ønsker til boligsalget',
  'objectForm.requirementsPlaceholder': 'Beskriv dine ønsker til f.eks. tidsplan, fremvisninger og salgspris.',
  'objectForm.uploadImages': 'Tilføj billeder (valgfrit)',
  'objectForm.autoDescription': 'Bodex opretter automatisk en beskrivelse af boligen.',
  'objectForm.noSalesRequirements': 'Ingen særlige ønsker til boligsalget',
  'objectForm.apartmentDetails': 'Oplysninger om lejligheden',
  'objectForm.houseDetails': 'Oplysninger om huset',
  'objectForm.vacationDetails': 'Oplysninger om fritidsboligen',
  'objectForm.plotDetails': 'Oplysninger om grunden',
  'objectForm.monthlyFee': 'Månedlige fællesudgifter (kr.)',
  'objectForm.balcony': 'Altan eller terrasse',
  'objectForm.balconyAndPatio': 'Altan og terrasse',
  'objectForm.plotSize': 'Grundareal (m²)',
  'objectForm.areaSize': 'Areal (m²)',
  'objectForm.heatingSystem': 'Opvarmning',
  'objectForm.directElectricity': 'Elvarme',
  'Balkong': 'Altan',
  'Uteplats': 'Terrasse',
  'Pellets': 'Træpiller',
  'objectForm.validation.addressLength': 'Adressen skal indeholde mindst 5 tegn.',
  'objectForm.validation.descriptionRequired': 'Skriv en beskrivelse af boligen.',
  'objectForm.validation.descriptionLength': 'Beskrivelsen skal indeholde mindst 10 tegn.',
  'objectForm.validation.descriptionMax': 'Beskrivelsen må højst indeholde 5.000 tegn.',
  'objectForm.validation.roomsRequired': 'Vælg antal værelser for denne boligtype.',
  'objectForm.validation.floorRange': 'Etagen skal være mellem 0 og 50.',
  'objectForm.validation.plotRange': 'Grundarealet skal være mellem 1 og 1.000.000 m².',
  'objectForm.validation.areaRange': 'Boligarealet skal være mellem 1 og 10.000 m².',
  'objectForm.validation.feeRange': 'De månedlige fællesudgifter skal være mellem 0 og 100.000 kr.',
  'objectForm.validation.yearRange': 'Byggeåret skal være mellem 1800 og 2030.',
  'objectForm.validation.timeout': 'Upload tog for lang tid. Prøv med mindre filer, eller kontrollér din internetforbindelse.',
  'objectForm.validation.invalidFile': 'Filformatet understøttes ikke. Du kan bruge JPG-, PNG- og WEBP-filer.',
  'objectForm.validation.badForm': 'Kontrollér, at alle felter er udfyldt korrekt.',
  'objectForm.validation.server': 'Der opstod en serverfejl. Prøv igen om lidt, eller kontakt support, hvis fejlen fortsætter.',
  'objectForm.validation.offline': 'Der er ingen internetforbindelse. Kontrollér forbindelsen, og prøv igen.',
  'objectForm.validation.network': 'Der opstod en netværksfejl. Kontrollér din internetforbindelse, og prøv igen.',
  'objectForm.validation.unexpected': 'Der opstod en uventet fejl. Prøv igen.',
  'objectDashboard.cityPlaceholder': 'Søg efter by',
  'objectDashboard.loading': 'Henter boliger...',
  'objectDashboard.loadError': 'Boligerne kunne ikke hentes. Prøv igen senere.',
  'objectDashboard.noResults': 'Ingen boliger matcher din søgning.',
  'objectDashboard.emptyTitle': 'Find boliger med søgefunktionen',
  'objectDashboard.emptySubtext': 'Søg efter adresse, by eller boligtype for at afgrænse resultaterne.',
  'objectDashboard.mapAlt': 'Kort over {address}',
  'objectDashboard.noImage': 'Intet billede tilgængeligt',
  'auth.loginToCreateAd': 'Log ind for at oprette en annonce',
  'auth.loginFailed': 'Du kunne ikke logge ind. Kontrollér dine oplysninger, og prøv igen.',
  'auth.registerTitle': 'Opret en konto',
  'auth.registerButton': 'Opret konto',
  'brokerSearch.loadError': 'Mæglerne kunne ikke hentes. Prøv igen senere.',
  'brokerSearch.results': 'Søgeresultater: {count} ejendomsmæglere',
  'brokerSearch.prompt': 'Søg efter en ejendomsmægler',
  'brokerSearch.noResults': 'Ingen ejendomsmæglere matcher din søgning.',
  'brokerSearch.emptyTitle': 'Find en ejendomsmægler med søgefelterne ovenfor',
  'brokerStart.title': 'For ejendomsmæglere',
  'brokerStart.intro': 'Kom i kontakt med boligejere, der overvejer at sælge.',
  'brokerStart.forBrokersBody1': 'Bodex forbinder ejendomsmæglere med boligejere, der overvejer et boligsalg. Her kan du finde nye kunder, præsentere dine ydelser og give et tilbud på salgsopgaven.',
  'brokerStart.forBrokersBody2': 'Som ejendomsmægler på Bodex kan du få adgang til salgshenvendelser, skrive med boligejere og vise, hvordan du kan hjælpe med deres boligsalg.',
  'brokerStart.leadTitle': 'Relevante salgshenvendelser',
  'brokerStart.leadBody': 'Få kontakt med boligejere, der har vist interesse for at sælge, og brug din tid på relevante salgsopgaver.',
  'brokerStart.timeBody': 'Saml dine henvendelser og din dialog med boligejerne ét sted. Det gør det lettere at følge op og holde overblik.',
  'brokerStart.transparentTitle': 'En gennemskuelig proces',
  'brokerStart.transparentBody': 'Gør det nemt for boligejeren at sammenligne dine ydelser og dit salær. Vis din erfaring, og skab tillid gennem en tydelig dialog.',
  'sellerLanding.welcomeNamed': 'Velkommen, {name}',
  'sellerLanding.welcome': 'Velkommen til din sælgerside',
  'sellerLanding.editContact': 'Rediger kontaktoplysninger',
  'sellerLanding.contactUpdated': 'Dine kontaktoplysninger er opdateret.',
  'sellerLanding.noListings': 'Du har endnu ikke oprettet en boligannonce. Kom i gang her:',
  'sellerLanding.createWithImages': 'Opret annonce med billeder',
  'sellerLanding.createSimple': 'Opret en enkel annonce',
  'sellerLanding.simpleTitle': 'Enkel annonce',
  'sellerLanding.simpleBody': 'Opret en annonce med de vigtigste oplysninger om boligen.',
  'sellerLanding.withImagesBody': 'Udfyld boligoplysningerne, tilføj billeder, og opret din annonce uden opfølgende spørgsmål.',
  'sellerLanding.aiBody': 'Besvar spørgsmål om boligen, og få hjælp fra AI til en mere udførlig annonce.',
  'sellerData.empty': 'Du har endnu ingen annoncer.',
  'sellerDataDetail.exactMap': 'Kortet viser boligens præcise beliggenhed.',
  'sellerDataDetail.approximateMap': 'Kortet viser boligens omtrentlige beliggenhed for at beskytte sælgerens privatliv. Den præcise adresse vises kun, hvis sælgeren har givet tilladelse.',
  'sellerDataDetail.contactSeller': 'Kontakt sælger',
  'brokerDashboard.title': 'Din mæglerprofil',
  'brokerDashboard.subtitle': 'Rediger din profil og dine virksomhedsoplysninger',
  'brokerDashboard.profileHelp': 'Et professionelt profilbillede er med til at skabe tillid hos boligsælgerne.',
  'brokerDashboard.upload': 'Gem billede',
  'brokerDashboard.uploading': 'Uploader...',
  'brokerDashboard.companyInfoHelp': 'Oplysninger om dit mæglerfirma',
  'brokerDashboard.monitoring': 'Boligovervågning',
  'brokerDashboard.noMonitoring': 'Ingen boligovervågning',
  'brokerDashboard.allObjects': 'Alle boliger',
  'brokerDashboard.cityObjects': 'Boliger i min by',
  'brokerDashboard.descriptionHelp': 'Fortæl om dig selv og dine ydelser',
  'brokerDashboard.noDescription': 'Der er endnu ingen beskrivelse.',
  'conversation.loadingConversations': 'Henter samtaler...',
  'conversation.loadError': 'Samtalerne kunne ikke hentes. Prøv igen senere.',
  'conversation.noMessagesYet': 'Ingen beskeder endnu',
  'conversation.noConversations': 'Du har endnu ingen samtaler.',
  'conversation.goToBrokerProfile': 'Se mæglerens profil',
  'conversation.viewObject': 'Se boligen',
  'conversation.fetchMessagesError': 'Beskederne kunne ikke hentes.',
  'conversation.emptyMessage': 'Skriv en besked, før du sender.',
  'conversation.tooLong': 'Beskeden må højst indeholde 5.000 tegn.',
  'conversation.sendError': 'Beskeden kunne ikke sendes. Prøv igen.',
  'conversation.placeholder': 'Skriv en besked...',
  'conversation.shareContact': 'Del mine kontaktoplysninger med mægleren',
  'conversation.contactShared': 'Mægleren har nu adgang til dine kontaktoplysninger. Dette kan ikke ændres.',
  'conversation.contactNotShared': 'Når du slår dette til, får mægleren adgang til dine kontaktoplysninger for at kunne oprette en mægleraftale.',
  'conversation.contactNotification': 'Jeg har nu givet dig adgang til mine kontaktoplysninger, så du kan oprette en mægleraftale.',
  'conversation.selectCounterparty': 'Vælg modtager:',
  'conversation.conversationWithSeller': 'Samtale med sælger, ID: {id}',
  'conversation.conversationWithBroker': 'Samtale med ejendomsmægler, ID: {id}',
  'conversation.expectedPrice': 'Forventet salgspris:',
  'conversation.expectedPricePlaceholder': 'f.eks. 3.500.000 kr.',
  'conversation.brokerFeePlaceholder': 'f.eks. 4 % af salgsprisen eller et fast salær på 50.000 kr.',
  'conversation.agreementNote': 'Når du starter en samtale, accepterer du, at Bodex opkræver 4,9 % af mæglersalæret ved et gennemført salg, hvis kontakten med kunden er etableret via Bodex. Det gælder, uanset om aftalen underskrives på eller uden for Bodex.',
  'conversation.startMessage': 'Din første besked:',
  'conversation.startMessagePlaceholder': 'Skriv din besked her.',
  'printLead.plotSize': 'Grundareal:',
  'smallWidgets.creatingAd': 'Opretter annonce',
  'smallWidgets.noOtherData': 'Ingen øvrige oplysninger eller dokumenter',
  'smallWidgets.uploadMultiple': 'Du kan uploade op til {max} filer',
  'smallWidgets.uploadError': 'Filerne kunne ikke uploades: {message}',
  'smallWidgets.deleteImageError': 'Billedet kunne ikke slettes.',
  'ad.publishError': 'Annoncens status kunne ikke opdateres. Prøv igen.',
  'ad.publish': 'Offentliggør',
  'ad.unpublish': 'Skjul annonce',
  'ad.view': 'Se annonce',
  'Blogg': 'Blog',
  'Laddar inlägg...': 'Henter indlæg...',
  'Senaste nyheterna och uppdateringarna från Bodex': 'Seneste nyt fra Bodex',
  'Inga inlägg än. Kom tillbaka snart!': 'Der er endnu ingen indlæg. Kig forbi igen snart.',
  'Av:': 'Af:',
  'Läs mer': 'Læs mere',
  'Inlägg hittades inte': 'Indlægget blev ikke fundet',
  'Inlägget existerar inte eller har tagits bort.': 'Indlægget findes ikke eller er blevet slettet.',
  'Tillbaka till blogg': 'Tilbage til bloggen',
  'Failed to fetch blog posts': 'Blogindlæggene kunne ikke hentes.',
  'Failed to fetch blog posts. Please try again later.': 'Blogindlæggene kunne ikke hentes. Prøv igen senere.',
  'Failed to fetch blog post': 'Blogindlægget kunne ikke hentes.',
  'Failed to fetch blog post. Please try again later.': 'Blogindlægget kunne ikke hentes. Prøv igen senere.',
};

export const getDanishDomesticCopy = (key, language, values, locationLike) => {
  const location = locationLike || (typeof window !== 'undefined' ? window.location : null);
  if (language !== 'dk' || !location || !isBodexDkHostname(location.hostname)
    || isSpanishMarketVisit(location)) return undefined;
  if (key === 'objectForm.room' && Number(values?.count) > 1) return 'værelser';
  return Object.prototype.hasOwnProperty.call(danishDomesticCopy, key)
    ? danishDomesticCopy[key] : undefined;
};
